import React from "react";

export default class CountdownTimer extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            remainingTime: props.seconds || 60
        };
        this.timerInterval = null;
    }

    componentDidMount() {
        this.startCountdown();
    }

    componentWillUnmount() {
        clearInterval(this.timerInterval);
    }

    startCountdown = () => {
        this.timerInterval = setInterval(() => {
            this.setState((prevState) => {
                if (prevState.remainingTime <= 1) {
                    clearInterval(this.timerInterval);
                    return { remainingTime: 0 };
                }
                return { remainingTime: prevState.remainingTime - 1 };
            });
            if(this.props.decreaseOtpExpirationTime){
                this.props.decreaseOtpExpirationTime();
            }
        }, 1000);
    };

    formatTime = (seconds) => {
        const mins = Math.floor(seconds / 60).toString().padStart(2, '0');
        const secs = (seconds % 60).toString().padStart(2, '0');
        return `${mins}:${secs}`;
    };

    render() {
        const { style } = this.props;

        return (
            <div style={style}>
                {this.formatTime(this.state.remainingTime)}
            </div>
        );
    }
}
